module.exports = __webpack_public_path__ + "static/media/tangocard.50ea4bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Dashboard/parts/ea/tangocard.png
// module id = 3013
// module chunks = 0